var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"418px","height":"220px"}},[(!_vm.finished)?_c('load-animation',{attrs:{"height":220,"width":418}}):_c('dv-scroll-board',{ref:"scrollBoard",staticStyle:{"width":"418px","height":"220px"},attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }